<template>
  <div>
    <modal modal-id="show-js-modal">
      <div slot="title">Copy JS code</div>
      <div slot="form">
        <h6>Place this code where you want to display the table.</h6>
        <div class="code-container">
          <pre>
            <code class="html hljs xml" id="code-block-1">
              &lt;casino-toplist-{{ toplist.tagKey }}&gt;&lt;/casino-toplist-{{ toplist.tagKey }}&gt;
            </code>
            <i class="fas fa-copy copy-icon" @click="copyCode"></i>
          </pre>
        </div>
        <h6>Place this code just before the closing &lt;/body&gt; tag</h6>
        <div class="code-container">
          <pre>
            <code class="html hljs xml" id="code-block-2">
              &lt;script src="{{scriptUrl}}"&gt;&lt;/script&gt;
              &lt;script&gt;
                ctl____get_configs({
                  id: '{{ toplist.tagKey }}',
                  template: '{{ toplist.template }}'
                });
              &lt;/script&gt;
            </code>
            <i class="fas fa-copy copy-icon" @click="copyCode"></i>
          </pre>
        </div>
      </div>
  </modal>
    <div v-if="toplist">
      <div class="row m-b-lg m-t-lg wrapper">
        <div class="col-md-12">
          <h3>
            {{ toplist.name }} - {{ toplist.website }}
          </h3>
          <button class="btn btn-xs btn-danger pull-right m-l-md" @click="deleteToplists()">Delete Toplists</button>
          <button class="btn btn-xs btn-success pull-right m-l-md" data-toggle="modal" data-target="#show-js-modal" ><i class="fa fa-code"></i> Get Code</button>
          <button class="btn btn-xs btn-primary pull-right" @click="generateToplists()">Generete Toplist</button>
        </div>
          <div class="row">
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Toplist Name</td>
                  <td>
                    <e-txt
                      type="editable"
                      :text="toplist.name"
                      @input="updateToplist($event, 'name')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>Website</td>
                  <td>
                    <e-txt
                      type="editable"
                      :text="toplist.website"
                      @input="updateToplist($event, 'website')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Template</td>
                  <td>
                    <e-txt
                      type="select"
                      :text="toplist.template"
                      :options="templates"
                      @input="updateToplist($event, 'template')"
                      select-value="id"
                      select-label="label"
                      close-on-save="true"
                      :selected-value="toplist.template"
                      :locked="!user.admin"
                    ></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>Tag ID</td>
                  <td>
                    {{ toplist.tagKey }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import EditText from '../../../Helpers/Form/EditText'
import axios from 'axios'
import { TOPLIST_SET } from '../../../../store/mutation-types'
import Modal from '../../../Helpers/Modal/Form'
import { Browser } from '../../../../mixins/helperMixin'

export default {
  data () {
    return {
      templates: [
        {label: 'Toplist', id: 'toplist'},
        {label: 'Small Logo Toplist', id: 'toplist-2'}
      ]
    }
  },
  computed: {
    ...mapGetters({
      toplist: 'getToplist',
      user: 'getUser'
    }),
    scriptUrl () {
      return `${process.env.API}/toplists/script/toplist-script.js`
    }
  },
  components: {
    eTxt: EditText,
    Modal
  },
  mixins: [Browser],
  mounted () {
    document.title = 'Toplist :: PBN360 by Aphex Media'
  },
  methods: {
    updateToplist (val, prop) {
      let data = {}
      data[prop] = val
      axios.patch(`/advertisers/toplists/${this.toplist.id}`, data)
        .then(r => {
          this.$toastr.success(`${prop} updated successfully`, 'Good')
          this.$store.commit(TOPLIST_SET, r.data)
        })
        .catch(e => {
          this.$toastr.error(e, 'Unable to update')
        })
    },
    async generateToplists () {
      try {
        if (!this.toplist.template) {
          alert('Select a template first.')
          return
        }
        await axios.post(`/advertisers/toplists/${this.toplist.id}/generate-html/${this.toplist.template}`)
        this.$toastr.success('Toplist Generated successfully')
      } catch (error) {
        this.$toastr.error('Failed to generate toplist', error)
      }
    },
    async deleteToplists () {
      if (!confirm('Do you want to delete this Toplist?')) {
        return
      }
      try {
        await axios.delete(`/advertisers/toplists/${this.toplist.id}`)
        this.$toastr.success('Toplist deleted successfully')
        this.$router.push({ name: 'Toplists' })
      } catch (error) {
        this.$toastr.error('Failed to delete toplist', error)
      }
    },
    copyCode (event) {
      const codeContent = event.target.previousElementSibling.textContent
      this.copyToClipboard(codeContent)
      this.$toastr.success('Code copied to clipboard')
    }
  }
}
</script>
<style>
.code-container {
   position: relative;
}
.copy-icon {
   position: absolute;
   top: 5px;
   right: 5px;
   cursor: pointer;
   opacity: 0.5;
   transition: opacity 0.3s;
}
.copy-icon:hover {
   opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/Toplist/Header.vue